<div class="upgrade-dialog-container">
  <button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon color="black">close</mat-icon>
  </button>
  <h2>{{ "subscription.new-usage.contact.popup-header" | translate }}</h2>
  <div [innerHTML]="'subscription.new-usage.contact.popup-text' | translate"></div>
</div>
